// components/FilterBar.js
export default function FilterBar({ filters, setFilters, searchTerm, setSearchTerm, types = [], subjects = [], grades = [] }) {
  const hasActiveFilters = searchTerm || 
    (filters.subject && filters.subject !== 'all') || 
    (filters.grade && filters.grade !== 'all') || 
    (filters.type && filters.type !== 'all');

  const handleClearAll = () => {
    setFilters({ subject: 'all', grade: 'all', type: 'all' });
    if (setSearchTerm) setSearchTerm('');
  };

  // Default types if not provided - must match ResourceType from backend/files/models.py exactly
  const defaultTypes = types.length > 0 ? types : [
    { id: 'all', label: 'כל הסוגים' },
    { id: 'teacher_guide', label: 'מדריכים למורה' },
    { id: 'presentation', label: 'מצגות' },
    { id: 'worksheet', label: 'דפי עבודה' },
    { id: 'quiz', label: 'בחנים' },
    { id: 'test', label: 'מבחנים' },
    { id: 'image', label: 'תמונות' },
    { id: 'video', label: 'סרטונים' },
    { id: 'game', label: 'משחקים' },
    { id: 'podcast', label: 'פודקאסטים' },
    { id: 'study_review', label: 'דפי לימוד וחזרה' },
    { id: 'lesson_plan', label: 'מערכי שיעור' },
    { id: 'sheets_havruta', label: 'לימוד בחברותות' },
    { id: 'sheets_parents', label: 'לימוד הורים וילדים' },
  ];

  // Default grades if not provided
  const defaultGrades = grades.length > 0 ? grades : [
    { id: 'all', label: 'כל הכיתות' },
    { id: 'ז', label: "כיתה ז'" },
    { id: 'ח', label: "כיתה ח'" },
    { id: 'ט', label: "כיתה ט'" },
    { id: 'י', label: "כיתה י'" },
    { id: 'י"א', label: 'כיתה י"א' },
    { id: 'י"ב', label: 'כיתה י"ב' },
  ];

  // Default subjects if not provided
  const defaultSubjects = subjects.length > 0 ? subjects : [
    { id: 'all', label: 'כל המקצועות' },
    { id: 'tosheva', label: 'תושב״ע' },
    { id: 'tanach', label: 'תנ״ך' },
    { id: 'machshevet', label: 'מחשבת ישראל' },
    { id: 'school_rabbis', label: 'רבני בתי ספר' },
  ];

  return (
    <div className="mb-8">
      <div className="flex flex-wrap md:flex-nowrap items-center gap-3 md:gap-4 p-4 bg-white dark:bg-secondary-800 rounded-lg border border-gray-100 dark:border-secondary-700 shadow-sm">
        <span className="font-bold text-gray-700 dark:text-gray-300 flex items-center gap-2 whitespace-nowrap flex-shrink-0 h-10">
        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z" />
        </svg>
        סינון:
      </span>
      
      <select 
        className="bg-gray-50 dark:bg-secondary-700 border border-gray-300 dark:border-secondary-600 text-gray-900 dark:text-gray-100 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 px-3 h-10 min-w-[140px] w-full md:flex-1 md:mt-5"
        value={filters.type || 'all'}
        onChange={(e) => setFilters({...filters, type: e.target.value})}
      >
        {defaultTypes.map(t => (
          <option key={t.id} value={t.id}>{t.label}</option>
        ))}
      </select>

      <select 
        className="bg-gray-50 dark:bg-secondary-700 border border-gray-300 dark:border-secondary-600 text-gray-900 dark:text-gray-100 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 px-3 h-10 min-w-[140px] w-full md:flex-1 md:mt-5"
        value={filters.grade || 'all'}
        onChange={(e) => setFilters({...filters, grade: e.target.value})}
      >
        {defaultGrades.map(g => (
          <option key={g.id} value={g.id}>{g.label}</option>
        ))}
      </select>

      <select 
        className="bg-gray-50 dark:bg-secondary-700 border border-gray-300 dark:border-secondary-600 text-gray-900 dark:text-gray-100 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 px-3 h-10 min-w-[140px] w-full md:flex-1 md:mt-5"
        value={filters.subject || 'all'}
        onChange={(e) => setFilters({...filters, subject: e.target.value})}
      >
        {defaultSubjects.map(s => (
          <option key={s.id} value={s.id}>{s.label}</option>
        ))}
      </select>

      {hasActiveFilters && (
        <button 
          onClick={handleClearAll}
          className="text-sm text-red-500 hover:text-red-700 dark:text-red-400 dark:hover:text-red-300 font-medium md:ml-auto whitespace-nowrap transition-colors h-10 flex items-center"
        >
          נקה הכל
        </button>
      )}
      </div>
    </div>
  );
}

